import React from 'react'

import Block from './Block'

import './styles.scss'
import { TYPE_OF_REVIEWERS } from 'app/constants/reviews'
import { DIRECT, PEERS, SELF, SUPERVISORS } from '../Reports'
const bc = 'reports-section'

const Section = ({ question, answers, reviewers }) => (
  <div className={bc}>
    <span className={`${bc}__question`} dangerouslySetInnerHTML={{ __html: question }} />
    <div className={`${bc}__content`}>
      <Block reviewerType={SELF} responses={answers[SELF]} customClassName={`${bc}__self`} />
      {!!reviewers[TYPE_OF_REVIEWERS.SUPERIOR] && (
        <Block reviewerType={SUPERVISORS} responses={answers[SUPERVISORS]} customClassName={`${bc}__superior`} />
      )}
      {!!reviewers[TYPE_OF_REVIEWERS.PEER] && (
        <Block reviewerType={PEERS} responses={answers[PEERS]} customClassName={`${bc}__peer`} />
      )}
      {!!reviewers[TYPE_OF_REVIEWERS.EMPLOYEE] && (
        <Block reviewerType="Direct Reports" responses={answers[DIRECT]} customClassName={`${bc}__employee`} />
      )}
    </div>
  </div>
)

export default Section
